import React from "react";

const Loader = () => (
  <div className={"loader"}>
    <div className="CDB-LoaderIcon CDB-LoaderIcon--big">
      <svg className="CDB-LoaderIcon-spinner" viewBox="0 0 50 50">
        <circle className="CDB-LoaderIcon-path" cx="25" cy="25" r="20" fill="none"></circle>
      </svg>
    </div>
  </div>
);

export default Loader;
